import React, { useState, useEffect } from 'react';
import img1 from "../../assets/bg1.png";
import img2 from "../../assets/bg2.png";
import img4 from "../../assets/bg4.png";
import img5 from "../../assets/bg5.png";
import { Box, AppBar, Toolbar, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import NavBar from "./navBar/navBar";
import HeroSection from "./sections/heroSection";

// Array of carousel images
const carouselImages = [img1, img2, img4, img5];

const Dashboard = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Auto-advance carousel every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        (prevIndex + 1) % carouselImages.length
      );
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  // Manual navigation functions
  const goToPrevious = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? carouselImages.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentImageIndex((prevIndex) =>
      (prevIndex + 1) % carouselImages.length
    );
  };

  // Carousel container style
  const carouselContainerStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    overflow: "hidden",
    zIndex: -1,
  };

  // Carousel track style that slides
  const carouselTrackStyle = {
    display: "flex",
    width: `${carouselImages.length * 100}%`,
    height: "100%",
    transform: `translateX(-${currentImageIndex * (100 / carouselImages.length)}%)`,
    transition: "transform 0.8s ease-in-out",
  };

  // Individual slide style
  const slideStyle = {
    width: `${100 / carouselImages.length}%`,
    height: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    backgroundRepeat: "no-repeat",
    backgroundAttachment: "scroll",
    minHeight: "100vh",
  };

  return (
    <Box
      sx={{
        display: "flex",
        position: "relative",
        minHeight: "100vh",
        width: "100%",
        overflowX: 'hidden'
      }}
    >
      {/* Sliding Carousel Container */}
      <Box sx={carouselContainerStyle}>
        <Box sx={carouselTrackStyle}>
          {carouselImages.map((image, index) => (
            <Box
              key={index}
              sx={{
                ...slideStyle,
                backgroundImage: `url(${image})`,
              }}
            />
          ))}
        </Box>
      </Box>
      {/* Navigation Arrows */}
      <IconButton
        onClick={goToPrevious}
        sx={{
          position: "absolute",
          left: { xs: 4, sm: 8, md: 20 },
          top: "50%",
          transform: "translateY(-50%)",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          color: "white",
          zIndex: 1000,
          width: { xs: 36, sm: 40 },
          height: { xs: 36, sm: 40 },
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
          },
        }}
      >
        <ChevronLeft fontSize="small" />
      </IconButton>

      <IconButton
        onClick={goToNext}
        sx={{
          position: "absolute",
          right: { xs: 4, sm: 8, md: 20 },
          top: "50%",
          transform: "translateY(-50%)",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          color: "white",
          zIndex: 1000,
          width: { xs: 36, sm: 40 },
          height: { xs: 36, sm: 40 },
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
          },
        }}
      >
        <ChevronRight fontSize="small" />
      </IconButton>

      {/* Dots Indicator */}
      <Box
        sx={{
          position: "absolute",
          bottom: 30,
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: 1,
          zIndex: 1000,
        }}
      >
        {carouselImages.map((_, index) => (
          <Box
            key={index}
            onClick={() => setCurrentImageIndex(index)}
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              backgroundColor: index === currentImageIndex ? "white" : "rgba(255, 255, 255, 0.5)",
              cursor: "pointer",
              transition: "background-color 0.3s ease",
              "&:hover": {
                backgroundColor: "white",
              },
            }}
          />
        ))}
      </Box>

      <AppBar component="nav" style={{ backgroundColor: "transparent" }}>
        <NavBar />
      </AppBar>

      <Box
        component="main"
        sx={{
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Toolbar />
        <HeroSection />
      </Box>
    </Box>
  );
};

export default Dashboard;